module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"#8b8b8b\" height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <polygon points=\"7 18.41 7 21 9 21 9 15 3 15 3 17 5.59 17 0.29 22.29 1.71 23.71 7 18.41\" />\n  <polygon points=\"17 3 15 3 15 9 21 9 21 7 18.41 7 23.71 1.71 22.29 0.29 17 5.59 17 3\" />\n  <polygon points=\"21 17 21 15 15 15 15 21 17 21 17 18.41 22.29 23.71 23.71 22.29 18.41 17 21 17\" />\n  <polygon points=\"3 7 3 9 9 9 9 3 7 3 7 5.59 1.71 0.29 0.29 1.71 5.59 7 3 7\" />\n  <circle cx=\"12\" cy=\"12\" r=\"3\" />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/collapse.svg
// module id = 788
// module chunks = 1